import { cn } from "@utils/design-utils";
import type { ElementType } from "react";
const themeColors = require("@theme/colors") as Record<string, any>;

export type CircleIconProps = {
  icon: ElementType<{ size?: number | string; color?: string; className?: string }>;
  size?: number;
  iconSize?: number;
  iconColor?: string;
  backgroundColor?: string;
  className?: string;
};

export const CircleIcon = ({
  icon: IconComponent,
  size = 40,
  iconSize,
  iconColor = "#000000",
  backgroundColor = themeColors.neutral.lightish,
  className,
}: CircleIconProps): JSX.Element => {
  return (
    <div
      className={cn("rounded-full flex items-center justify-center", className)}
      style={{ width: size, height: size, backgroundColor }}
    >
      <IconComponent size={iconSize ?? Math.max(size * 0.45, 12)} color={iconColor} />
    </div>
  );
};
